import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import useQueue from '../hooks/useQueue.js';
import SeatReserve from './SeatReserve';
import QueueWait from './QueueWait.js';
import { Modal } from 'react-responsive-modal';
import SeatReserveMy from './SeatReserveMy';
import moment from 'moment';
import '../css/queue.css';
// import io from 'socket.io-client';
// const ramdomId = () => {
//   return Math.random().toString(36).substr(2, 11);
// };

const Seat = (props) => {
  const { loginId, history } = props;
  const [listShow, setListShow] = useState(false);
  const [seatShow, setSeatShow] = useState(false);
  const [userId, setUserId] = useState();
  const ticketCode = 28;

  const {
    queue,
    position,
    reservationCount,
    estimatedWaitTime,
    move,
    joinQueue,
    leaveQueue,
    allLeaveQueue,
    setMove,
    leaveReservation,
  } = useQueue(loginId);

  // console.log('move', move);

  if (loginId === null || loginId === undefined || loginId === '') {
    history.push('/login');
    return null;
  }
  const unload = async () => {
    leaveQueue();
    console.log('seat unload ................');
    // leaveQueue();
  };

  const _info = () => {
    if (loginId) {
      setListShow(true);
    } else {
      alert('로그인후 이용해 주세요.');
    }
  };
  const _seat = () => {
    setSeatShow(true);
  };

  const _popupClose = () => {
    setListShow(false);
  };

  useEffect(() => {
    window.addEventListener('beforeunload', unload);

    return () => {
      // console.log('disconnect.......');
      //alert(0);
      // leaveQueue(socekt);
      window.removeEventListener('beforeunload', unload);
    };
  }, []);

  return (
    <>
      {move ? (
        <SeatReserve
          leaveQueue={leaveQueue}
          leaveReservation={leaveReservation}
        />
      ) : (
        <>
          <QueueWait
            leaveQueue={leaveQueue}
            position={position}
            estimatedWaitTime={estimatedWaitTime}
            setSeatShow={setSeatShow}
            setListShow={setListShow}
          />
          {/* <div className="queue-container">
            <div className="queue-info">
              <h2 className="">{loginId}님</h2>
              <h2>현재 동시 접속자가 많아 접속 대기 중입니다.</h2>

              <p className="queue-info-p">
                {position !== -1 ? (position + 1).toLocaleString('ko-KR') : '0'}{' '}
                명이 내 앞에 대기하고 있습니다.
              </p>
              <p className="queue-info-p-1">
                예상 대기시간: {estimatedWaitTime}분
              </p>

              <p className="queue-notice">
                대기 순서에 따라 자동 접속되니 조금만 기다려 주세요
              </p>
              <p className="queue-notice">
                새로고침 또는 뒤로가기를 하시면 다시 대기시간이 부여됩니다.
              </p>
              <p className="queue-notice-1">
                * 최대 5분간 대기 숫자의 변동이 없다면 새로고침을 시도해 주세요.
              </p>
            </div>
            <div className="btn-box">
              <div className="btn-seat" onClick={() => setSeatShow(true)}>
                극장 좌석표{' '}
              </div>
              <div className="btn-info" onClick={() => setListShow(true)}>
                나의 예매정보{' '}
              </div>
            </div>
          </div> */}
        </>
      )}

      <Modal
        open={seatShow}
        showCloseIcon={false}
        //closeOnOverlayClick={true}
        //closeOnEsc={true}
        center
        styles={{
          modal: {
            backgroundColor: 'black',
          },
        }}
      >
        <div onClick={() => setSeatShow(false)} style={{ cursor: 'pointer' }}>
          <div
            style={{
              position: 'absolute',
              right: -20,
              top: 80,
              zIndex: 99999999,
            }}
            onClick={() => setSeatShow(false)}
          >
            <img src="/img/seat/pop_close.png" />
          </div>
          <img src="/img/event/event20260311/sitting_list_2.jpg" />
        </div>
      </Modal>
      <Modal
        open={listShow}
        showCloseIcon={false}
        closeOnOverlayClick={true}
        closeOnEsc={true}
        center
        styles={{
          modal: {
            backgroundColor: 'black',
          },
        }}
      >
        <SeatReserveMy
          ticketCode={ticketCode}
          charImg=""
          popupClose={_popupClose}
          // socket={socket}
        />
      </Modal>
    </>
  );
};

export default shopContext(withRouter(Seat));
